import axiosInstance from 'network/apis/index'
import { microServices } from 'network/apis/microservice/index'
import { SuccessMessage } from 'network/messageTranslationHelpers/messages'
import { METHOD_TYPES } from 'utils/constants/index'

export const placeBetCrashGameService = (data) => {
  return axiosInstance(METHOD_TYPES.post, '/fast-games/crash-game/place-bet-crash-game', data, {
    server: microServices.USER_URL,
    successMessage: SuccessMessage.betPlacedSuccessfully
  })
}
export const escapeCrashBetService = (data) => {
  return axiosInstance(METHOD_TYPES.post, '/fast-games/crash-game/player-escape-crash-game', data, {
    server: microServices.USER_URL
  })
}

export const cancelCrashBetService = (data) => {
  return axiosInstance(METHOD_TYPES.post, '/fast-games/crash-game/cancel-bet-crash-game', data, {
    server: microServices.USER_URL,
    successMessage: SuccessMessage.betCancelledSuccessfully
  })
}
export const getAllRoundHistoryService = () => {
  return axiosInstance(METHOD_TYPES.get, '/fast-games/crash-game/get-crash-game-history', {
    server: microServices.USER_URL
  })
}

export const getMyBetsService = (params) => {
  return axiosInstance(METHOD_TYPES.get, '/fast-games/crash-game/my-bets', {}, {
    params,
    server: microServices.USER_URL
  })
}
export const getPreviousRoundBetsService = (params) => {
  return axiosInstance(METHOD_TYPES.get, '/fast-games/crash-game/previous-round-placed-bets', {}, {
    params,
    server: microServices.USER_URL
  })
}

export const getTopBetsService = (params) => {
  return axiosInstance(METHOD_TYPES.get, '/fast-games/crash-game/top-bets', {}, {
    params,
    server: microServices.USER_URL
  })
}

export const verifyProvableFairCrashService = (data) => {
  return axiosInstance(METHOD_TYPES.post, '/fast-games/crash-game/check-provable-fair', data, {
    server: microServices.USER_URL
  })
}
